import styled from 'styled-components';

export const PartyJackpotInGameWidgetAmountContainerBox = styled.div`
    color: ${props => props.theme.components.partyJackpotInGameWidget.colors.amount};
    width: 100%;
    text-align: center;
    font-family: ${props => props.theme.font.family.ultra};
    font-size: 32px;
    letter-spacing: 1.3px;
    margin-bottom: 3px;

    @media ${({theme}) => theme.mediaQuery.xlExact} {
        font-size: 21px;
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 13px;
        letter-spacing: 0.65px;
        margin-bottom: 3px;
    }
`;
